import React from "react";
import { X, Film, Image as ImageIcon } from "lucide-react";
import {
  STATUS_LABELS_AR,
  PRIORITY_LABELS_AR,
  statusBadgeClass,
  priorityBadgeClass,
  isVideoFileType,
  resolveMediaUrl,
} from "./ticketUi";

export function TicketStatusBadge({ status }) {
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs md:text-sm font-semibold ${statusBadgeClass(status)}`}>
      {STATUS_LABELS_AR[status] || status}
    </span>
  );
}

export function TicketPriorityBadge({ priority }) {
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs md:text-sm font-semibold ${priorityBadgeClass(priority)}`}>
      {PRIORITY_LABELS_AR[priority] || priority}
    </span>
  );
}

export function AttachmentPreview({ attachment, onRemove, compact = false }) {
  const url = attachment.previewUrl || resolveMediaUrl(attachment.filePath);
  const video = attachment.isVideo || isVideoFileType(attachment.fileType);

  return (
    <div
      className={`relative group border border-gray-200 rounded-xl overflow-hidden bg-gray-50 ${
        compact ? "w-20 h-20" : "w-28 h-28"
      }`}
    >
      {video ? (
        <video src={url} className="w-full h-full object-cover" muted playsInline />
      ) : url ? (
        <img src={url} alt={attachment.fileName || "attachment"} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-gray-400">
          {video ? <Film size={22} /> : <ImageIcon size={22} />}
        </div>
      )}
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition"
        title={attachment.fileName}
      />
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="absolute top-1 left-1 bg-white/90 text-red-600 rounded-full p-0.5 shadow"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
